<template>
    <div v-if="reference" :class="{ 'replying': isReplying }" style="position:relative">
        <div v-if="showBottom" class="down-button" @click="handleGoBottom">
            <li class="fa fa-angle-down"></li>
        </div>
        <div ref="chatbox" class="chatbox" @scroll="handleScroll">
        <div class="no-comments" v-if="allComments.length == 0">No comments</div>
        <note
                v-for="note in allComments"
                :key="note.id"
                :item="note"
                class="media"
                :class="{ 'note-reply': note.parent_id }"
                @reply="reply"
                @endreply="endReply"
                :isParentReplying="isReplying"
                :focusonload="note.id == focusNoteId"
        />
        </div>
        <article class="media note-editor">
            <div class="media-content quill-media">
                <div class="field">
<!--                    <b-quill-->
<!--                            ref="quillEditor"-->
<!--                            :error="getError('message')"-->
<!--                            v-model="message"-->
<!--                            :users="allUsers"-->
<!--                            :hashes="allTasks"-->
<!--                    />-->
                  <quill-editor content-type="html" v-model:content="message" :class="{'is-danger': hasError}" :options="editorOptions" ref="editor"/>


                </div>

                <div class="level thread-level">
                    

                    <div class="level-right">
                        <div class="level-item">
                            <uploadcare
                                    ref="ucare"
                                    :multiple="true"
                                    v-model="files"
                                    format="object"
                            />
                        </div>

                        <div class="level-item">
                            <button
                                    v-submit="submitting"
                                    class="button is-dark"
                                    @click.prevent="handleCreate"
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <o-modal
:can-cancel="['escape', 'outside', 'button']"                :active.sync="isSubscribersModalActive"
                has-modal-card
        >
            <subscribers-modal :note="currentNote"/>
        </o-modal>
    </div>
</template>

<script>
    import SubscribedContacts from './NotesSubscribedContacts'
    import SubscribersModal from './modals/Subscribers'
    import HandlesForm from '../mixins/HandlesForm'
    import Subscribers from './NotesSubscribers'
    import {mapActions, mapGetters} from 'vuex'
    import Multiselect from '@vueform/multiselect'
    import Uploadcare from './Uploadcare'
    import Note from './NoteComment'
import ReportTableVue from '../pages/dashboards/tabs/billing-dashboard/ReportTable.vue'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
        components: {
          QuillEditor,
            SubscribedContacts,
            SubscribersModal,
            Multiselect,
            Subscribers,
            Uploadcare,
            Note
        },

        mixins: [HandlesForm],

        props: ['referenceId', 'referenceType', 'entity', 'focusNoteId'],
        mounted() {
           
        },
        data() {
            return {
                submittingSubscribedContacts: false,
                isSubscribersModalActive: false,
                submittingSubscribers: false,
                is_milestone: false,
                currentNote: null,
                external: false,
                subject: '',
                text: '',
                files: [],
                isReplying: false,
                replyingTo: null,
                showBottom: true,
              editorOptions: {
                modules: {
                  toolbar: [
                    [{ 'font': [] }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'indent': '-1'}, { 'indent': '+1' }],
                    ['clean'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    // [{ 'script': 'sub'}, { 'script': 'super' }],
                    //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    ['link'],
                    ['image'],


                  ],
                }
              },
            }
        },

        computed: {
            ...mapGetters(['allUsers', 'notesByReference', 'remindersByReference' , 'currentUser', 'projectById', 'proposalById', 'taskById', 'tasksByProjectId', 'currentProjectId', 'projectServiceById']),

            allComments() {
                let notes = this.notes
                let reminders = this.reminders
                return [...reminders, ...notes]
            },

            notes() {
                const notes = this.notesByReference(this.referenceType, this.referenceId)
                let proposalNotes = []
                if(this.referenceType === 'project') {
                    proposalNotes = this.notesByReference('proposal', this.referenceId)
                }
                
                let result = [...notes, ...proposalNotes]
               return  _.sortBy(result, p => `${(p.parent_id ? p.parent_id  : p.id)}${moment(p.created_at).valueOf()}`)
            },
            reminders() {
               let result = _.map(this.remindersByReference(this.referenceType, this.referenceId), p =>  { return { id: p.id, message: p.description, remind_at: p.remind_at, actor_id: p.user_id, created_at: p.created_at } })
                return _.sortBy(result, p => `${moment(p.created_at).valueOf()}`)
            },
            reference() {
                switch (this.referenceType) {
                    case 'email':
                        return this.entity
                    case 'task':
                        return this.taskById(this.referenceId)
                    case 'proposal':
                        return this.proposalById(this.referenceId)
                    case 'project':
                        return this.projectById(this.referenceId)
                    case 'project-service':
                        return this.projectServiceById(this.referenceId)
                }
            },

            isExternal: {
                get() {
                    return !!this.reference.is_external
                },
                set(value) {
                    this.reference.is_external = value
                }
            },

            canBeExternal() {
                return this.referenceType != 'proposal'
            },
            allTasks(){
                return _.map(this.tasksByProjectId(this.currentProjectId), p => { return { id: p.id, value: `Task: ${p.title}`, denotationChar: '#' }})
            }
        },

        watch: {
            submittingSubscribers() {
                this.submitting = this.submittingSubscribers || this.submittingSubscribedContacts
            },

            submittingSubscribedContacts() {
                this.submitting = this.submittingSubscribers || this.submittingSubscribedContacts
            }
        },

        methods: {
            ...mapActions(['createNote', 'partialUpdateTask', 'partialUpdateProject']),

            handleCreate() {
                let submit = this.wrapSubmit(this.createNote)

                submit({
                    message: this.message, files: this.files ? this.files : [],
                    reference_type: this.referenceType,
                    is_milestone: this.is_milestone,
                    reference_id: this.referenceId,
                    subject: `${this.referenceType} #${this.referenceId} Notes`,
                    parent_id: this.isReplying ? this.replyingTo : null
                    // external: this.external
                }).then(res => {
                    this.is_milestone = false
                    this.$refs.ucare.clear()
                    this.subject = ''
                    this.message = ''
                    this.isReplying = false
                    this.$emit('created', this.referenceType, this.referenceId)
                    return res
                })
            },

            partialUpdate() {
                let payload = {
                    is_external: this.reference.is_external,
                    id: this.reference.id,
                    field: 'is_external'
                }

                switch (this.referenceType) {
                    case 'task':
                        return this.partialUpdateTask(payload)
                    case 'project':
                        return this.partialUpdateProject(payload)
                    // not applicable for proposals
                    case 'proposal':
                    default:
                        break
                }
            },

            reply(note) {
                this.$emit('onreply', note)
                this.isReplying = true
                this.replyingTo = note.parent_id ? note.parent_id : note.id
                this.$refs.quillEditor.$children[0].quill.focus()
            },
            endReply() {
                this.isReplying = false
            },
            handleScroll(e) {
                let chatBox = this.$refs.chatbox;
                if(this.showBottom && chatBox.scrollTop >= chatBox.scrollHeight - chatBox.clientHeight) {
                    this.showBottom = false
                } else if (!this.showBottom && chatBox.scrollTop < chatBox.scrollHeight - chatBox.clientHeight ) {
                    this.showBottom = true
                }
            },
            handleGoBottom() {
                this.$refs.chatbox.scrollBy(0,this.$refs.chatbox.scrollHeight)
            }
        }
    }
</script>
<style>
</style>